import { createPageNavigator } from "@-/dev.improve.haniverse.lib.navigator.page";
import { useCallback } from "react";

function useNavigator() {
  return useCallback(
    () => ({
      href: {
        pathname: "/(nav)/(app)/settings/account",
      },
      queries: [],
    }),
    [],
  );
}

export const useAccountSettingsPageNavigator = createPageNavigator<void>({
  useNavigator,
});
